export default {"src":"/_next/static/media/images.6ed2deb6.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};